import { Component, OnInit, Host } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { StolenCamerasService } from "./stolencameras.service";
import { StolenCamera } from "../../api-models/StolenCamera";
import { StolenCamerasMainComponent } from "./stolencameras.main.component";

@Component({
    selector: "app-stolencameras",
    templateUrl: "./stolencameras.component.html",
    styleUrls: ["stolencameras.component.scss"],
    standalone: false
})
export class StolenCamerasComponent extends BaseMaterialDatatableComponent<StolenCamera> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: StolenCamera[] = [];

    constructor(
        private stolenCamerasService: StolenCamerasService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: StolenCamerasMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: stolenCamerasService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_stolencameras_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["camowner", "camera", "city", "country", "created", "updated", "actions"],
            listService: stolenCamerasService
        });

        this.UTCDATEFORMAT = this.stolenCamerasService.UTCDATEFORMAT;
    }

    // _dataTableTrigger() {
    //     return (dataTableParameters: DataTableParameters, callback: Function) => {
    //         // get api query parameters by datatable
    //         const queryParams = this.getApiQueryParamsByDataTable(dataTableParameters);

    //         this.subscriptions.push(
    //             this.stolenCamerasService.stolenCameras(queryParams).subscribe((result) => {
    //                 this.rows = result.list;

    //                 callback({
    //                     recordsTotal: result.total,
    //                     recordsFiltered: result.count,
    //                     data: []
    //                 });
    //             })
    //         );
    //     };
    // }

    editStolenCamera(id?: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteStolenCamera(id?: string) {
        const initialState = {
            title: this.translateService.instant("stolencameras.list.delete.title"),
            message: this.translateService.instant("stolencameras.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        if (bsModalRef.content) {
            bsModalRef.content.confirmCallback = () => {
                if (!id) {
                    return;
                }

                this.subscriptions.push(
                    this.stolenCamerasService.deleteStolenCamera(id).subscribe((result) => {
                        this.alertService.addSuccess(this.translateService.instant("stolencameras.list.delete.success"));
                        this.loadData();
                    })
                );
            };
        }
    }
}
